import React from 'react'
import { ScorecardSection } from './ScorecardSection'
import { ScorecardResult, Scorecard as ScorecardModel } from '../../../../../models/Scorecard'
import { getLabel, ScorecardLabelLevel } from '../../../../../common/clientProfile'
import { parseMetadata } from '../utils'
import { Col, Row } from 'react-bootstrap'
import { ClientProfileSection } from '../../../../../views/ClientProfile/ClientProfileSection'

interface ScorecardBlockProps {
  vkey: string
  value: { [key: string]: any }
  scorecard: ScorecardModel
  scorecardResult: ScorecardResult
}

export const ScorecardBlock: React.FC<ScorecardBlockProps> = ({ vkey, value, scorecard, scorecardResult }) => {
  const shouldRenderBlockLabel = () => {
    if (!scorecard.metadata) {
      return true
    }
    const metadata = parseMetadata(scorecard.metadata)
    return !(metadata && metadata.labelConfig && metadata.labelConfig[ScorecardLabelLevel.BLOCK] === 'skip')
  }

  return (
    <Row className='gap-0' key={`block.row.${vkey}`}>
      <Col>
        {shouldRenderBlockLabel() && (
          <span className='scorecard-root-property'>{getLabel(scorecard.descriptor, vkey, value, ScorecardLabelLevel.BLOCK, scorecard.metadata)}</span>
        )}
        <ScorecardSection vkey={vkey} value={value} scorecard={scorecard} scorecardResult={scorecardResult} />
      </Col>
    </Row>
  )
}
